// extracted by mini-css-extract-plugin
export default {"marcWrapper":"marcWrapper---EsC1w","marc":"marc---RvYCZ"};